'use strict';
'use es6';

/**
 * @description Capture action breadcrumbs in sentry
 * @param {Object} action Action to add as a breadcrumb
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var captureActionBreadcrumb = exports.captureActionBreadcrumb = function captureActionBreadcrumb(action) {
  window.Raven.captureBreadcrumb({
    message: action.type,
    category: 'redux action'
  });
};